export function InvoiceSerialNumbersCtrl (
  $uibModalInstance,
  $q,
  $scope,
  $timeout,
  $translate,
  available_serial_numbers,
  confirm,
  editable,
  item,
  messages,
  selected_serial_numbers,
  workshopAPI,
) {

  $scope.allSelected              = false;
  $scope.available_serial_numbers = available_serial_numbers || [];
  $scope.editable                 = editable;
  $scope.flipped                  = false;
  $scope.item                     = item || [];
  $scope.selected_serial_numbers  = selected_serial_numbers || [];
  $scope.serial_numbers           = selected_serial_numbers || [];
  $scope.selectedItems            = [];

  $scope.tableSettings = {
    columns: [
      {
        classes: 'text-left',
        field  : 'serial_number',
        header : {
          text: $translate.instant('SERIAL_NUMBER_SPACE.SERIAL_NUMBER')
        }
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_SERIAL_NUMBERS_SELECTED')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true,
        multi  : true
      }
    },
    sorting: {
      direction: 'desc',
      enabled  : true,
      field    : 'serial_number'
    },
  };

  $scope.onRowClick = function () {
    $scope.selectedItems = $scope.serial_numbers.filter((row) => row.selected);

    $scope.allSelected = ($scope.selectedItems.length == $scope.serial_numbers.length);
  };

  $scope.canAddMore = function () {
    const required = new BigDecimal($scope.item.quantity.toString());
    const selected = new BigDecimal($scope.selected_serial_numbers.length.toString());

    return required.isGreaterThan(selected);
  };

  $scope.close = function () {
    if ($scope.canAddMore()) {
      return confirm.generic($translate.instant('SERIAL_NUMBER_SPACE.SELECTED_NOT_ENOUGH'))
      .then(() => {
        $uibModalInstance.close();
      });
    }

    $uibModalInstance.close();
  };

  $scope.delete = function () {
    confirm.generic($translate.instant('SERIAL_NUMBER_SPACE.REMOVE_FROM_INVOICE_CONFIRM'))
    .then(() => {
      return workshopAPI.patch('/product_serial_numbers/remove_serial_numbers', {
        item          : $scope.item,
        serial_numbers: $scope.selectedItems
      }, 'product_serial_number');
    })
    .then(selected_serial_numbers => {
      $scope.serial_numbers            = selected_serial_numbers || [];
      $scope.selected_serial_numbers   = selected_serial_numbers;
      $scope.selectedItems.length = 0;

      messages.show($translate.instant('SERIAL_NUMBER_SPACE.REMOVED_FROM_INVOICE'), 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.flipToAddSerialNumber = function () {
    workshopAPI.get('/product_serial_numbers/serial_number_list_by_product',  [$scope.item.product_id, true])
    .then(available_serial_numbers => {
      $scope.serial_numbers            = available_serial_numbers || [];
      $scope.selected_serial_numbers   = selected_serial_numbers;
      $scope.selectedItems.length = 0;
      $scope.flipped                   = !$scope.flipped;

      $scope.$emit('flipModal');
    });
  };

  $scope.flipToViewSerialNumber = function () {
    workshopAPI.get('/product_serial_numbers/serial_number_list_by_invoice_item',  [ $scope.item.id ])
    .then(selected_serial_numbers => {
      $scope.serial_numbers            = selected_serial_numbers || [];
      $scope.selected_serial_numbers   = selected_serial_numbers;
      $scope.selectedItems.length = 0;
      $scope.flipped                   = !$scope.flipped;

      $scope.$emit('flipModal');
    });
  };

  $scope.selectAll = function () {
    $scope.allSelected = !$scope.allSelected;

    angular.forEach($scope.serial_numbers, function (row) {
      row.selected = $scope.allSelected;
    });

    $scope.selectedItems = $scope.serial_numbers.filter((row) => row.selected);
  };

  $scope.useSerialNumber = function () {
    workshopAPI.get('/product_serial_numbers/serial_number_list_by_invoice_item',  [$scope.item.id])
    .then(selected_serial_numbers => {
      $scope.selected_serial_numbers = selected_serial_numbers;

      return $scope.selectedItems.length + $scope.selected_serial_numbers.length;
    })
    .then(serial_number_count => {
      if (serial_number_count > $scope.item.quantity) {
        return $q.reject($translate.instant('SERIAL_NUMBER_SPACE.SELECTED_MORE_THAN_REQUIRED'));
      }
      return serial_number_count < $scope.item.quantity ?
        confirm.generic($translate.instant('SERIAL_NUMBER_SPACE.SELECTED_NOT_ENOUGH')) :
        $q.when(true);
    })
    .then(() =>  workshopAPI.patch('/product_serial_number/attach_serial_number_to_invoice_item', {
      item          : $scope.item,
      serial_numbers: $scope.selectedItems
    } ,'product_serial_number'))
    .then(selected_serial_numbers => {
      $scope.selected_serial_numbers   = selected_serial_numbers;
      $scope.serial_numbers            = selected_serial_numbers;
      $scope.selectedItems.length = 0;
      $scope.flipped                   = !$scope.flipped;

      $scope.$emit('flipModal');
    })
    .catch(err => {
      messages.error(err);
    });
  };

  if (!$scope.selected_serial_numbers.length) {
    $timeout(() => {
      $scope.flipToAddSerialNumber();
    });
  }
}